import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "check-result" }
const _hoisted_2 = { class: "area" }
const _hoisted_3 = {
  key: 0,
  class: "inner"
}
const _hoisted_4 = {
  key: 1,
  class: "inner"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "info" }, " Das Abschließen speichert den aktuellen Fragebogen und Ihre Antworten! ", -1)
const _hoisted_7 = { class: "navigation" }

import {useApiClient} from "@/api";
import {useRouter} from "vue-router";
import {useStore} from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResultScreen',
  props: {
    completed: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const api = useApiClient()
const store = useStore()
const router = useRouter()

const save = async () => {
  await store.dispatch('SAVE_QUESTIONNAIRE')
  await router.push({ name: 'menu' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.completed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Sie haben den Frageboxen nun vollständig ausgefüllt und können den Fragebogen nun abschließen. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, " Sie haben den Fragebogen noch nicht vollständig ausgefüllt und können den Fragebogen daher nicht abschließen. "))
    ]),
    _createElementVNode("button", {
      disabled: !_ctx.completed,
      onClick: save
    }, " Fragebogen abschließen ", 8, _hoisted_5),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "navigation")
    ])
  ]))
}
}

})